var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-button',{on:{"click":_vm.agregar}},[_vm._v("Agregar")]),_c('proyectos')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }